import { render, staticRenderFns } from "./UserAlerts.vue?vue&type=template&id=aadef9f0&scoped=true"
import script from "./UserAlerts.vue?vue&type=script&lang=js"
export * from "./UserAlerts.vue?vue&type=script&lang=js"
import style0 from "./UserAlerts.vue?vue&type=style&index=0&id=aadef9f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aadef9f0",
  null
  
)

export default component.exports